export default { sha: 'e5b653d59d85a5f238dabaa57604086025aece00', buildNumber: 'undefined' }
